import * as React from 'react'

import { MobXProviderContext } from 'mobx-react'

import type { MaterialResource } from '~/client/src/shared/resources/domain/materialResource'
import type { MaterialResourceDomainFailure } from '~/client/src/shared/resources/domain/materialResourceTypeDefinition'
import { requireMaterialResourceSuccess } from '~/client/src/shared/resources/presentation/requireMaterialResourceSuccess'
import type ProjectResourcesStore from '~/client/src/shared/stores/domain/ProjectResources.store'

import {
  ProjectResourceStoreView,
  useProjectResourceStore,
} from './useProjectResourceStore'

type MaterialResourcesStore = ProjectResourcesStore<
  MaterialResource,
  MaterialResourceDomainFailure
>

interface MaterialResourceStoreContext {
  readonly materialResourcesStore: MaterialResourcesStore
}

/** Observable project view exposed to React Material consumers. */
export type MaterialResourceStoreView = ProjectResourceStoreView<
  MaterialResource,
  MaterialResourceDomainFailure
>

/** Projects the shared Material Resource store for one project. */
export function useMaterialResourceStore(
  projectId?: string,
): MaterialResourceStoreView {
  const { materialResourcesStore } = React.useContext(
    MobXProviderContext,
  ) as MaterialResourceStoreContext

  return useProjectResourceStore(
    projectId,
    materialResourcesStore,
    requireMaterialResourceSuccess,
  )
}
